<template>
  <div>
    <div id="heatmapchart" ref="heatmapchart"></div>
  </div>
</template>
<script>
export default {
  name: "HeatMap",
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  methods: {
    initChart() {
      var options = {
        series: [
          {
            name: "Jun",
            data: this.generateData(5, {
              min: 0,
              max: 90,
            }),
          },
          {
            name: "Jul",
            data: this.generateData(5, {
              min: 0,
              max: 90,
            }),
          },
          {
            name: "Aug",
            data: this.generateData(5, {
              min: 0,
              max: 90,
            }),
          },
          {
            name: "Sep",
            data: this.generateData(5, {
              min: 0,
              max: 90,
            }),
          },
          {
            name: "Oct",
            data: this.generateData(5, {
              min: 0,
              max: 90,
            }),
          },
        ],
        chart: {
          height: 230,
          type: "heatmap",
          toolbar: {
            show: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        colors: ["#008FFB"],
        title: {
          text: "",
        },
      };

      var chart = new ApexCharts(document.querySelector("#heatmapchart"), options);
      chart.render();
    },

    generateData(count, yrange) {
      var series = [];
      var i = 0;
      while (i < count) {
        var y = Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min;
        series.push(y);
        i++;
      }
      return series;
    },
  },
};
</script>
